// extracted by mini-css-extract-plugin
export default {"radio":"Radio_radio__UDpJs","disabled":"Radio_disabled__6PIYN","label":"Radio_label__HTDm6"};